import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-oc-detail" }

import { onMounted, reactive } from 'vue';
  import { useRoute } from 'vue-router';
  import { request } from '@/utils';
  import { IOfflineCollection, getOfflineCollectionDefaultData } from '@/types/offline-collection';
  import { mineBreadcurmbStore } from '@/stores';
  import Record from '@/components/offline-collection/record.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const detail = reactive(getOfflineCollectionDefaultData());

  onMounted(async () => {
    const { data } = await request.get<IOfflineCollection>(`mine/offline_collections/${route.params.id}`);
    Object.assign(detail, data);
    mineBreadcurmbStore.update([{
      name: detail.name
    }]);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(detail).id)
      ? (_openBlock(), _createBlock(Record, {
          key: 0,
          type: "OfflineCollection",
          title: _unref(detail).name,
          "collection-method": _unref(detail).collection_method,
          "collection-state": _unref(detail).state
        }, null, 8, ["title", "collection-method", "collection-state"]))
      : _createCommentVNode("", true)
  ]))
}
}

})